import React from 'react'

const Chevron = ({ direction }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8.496" viewBox="0 0 14 8.496">
        <path id="Icon_awesome-chevron-down" data-name="Icon awesome-chevron-down" d="M6.854,16.954.623,10.723a.769.769,0,0,1,0-1.088l.727-.727a.769.769,0,0,1,1.087,0L7.4,13.845l4.961-4.938a.769.769,0,0,1,1.087,0l.727.727a.769.769,0,0,1,0,1.088L7.942,16.954A.769.769,0,0,1,6.854,16.954Z" transform="translate(-0.397 -8.683)" fill="#363636" />
    </svg>



)

export default Chevron;